module.exports = __webpack_public_path__ + "img/changjiangLOGO.e4877cd2.png";